import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { boy } from "../components/SmallComponents/Images";

function About() {
  return (
    <Box mb={2} mt={{ xs: 10, md: 15 }} id="about">
      <Container maxWidth={"xl"}>
        <Grid container spacing={{ xs: 2, sm: 4 }} justifyContent={"center"}>
          <Grid
            item
            xs={12}
            md={6}
            order={{ xs: 2, md: 1 }}
            display="flex"
            justifyContent="center"
          >
            <Box>
              <Box
                component={"img"}
                alt=""
                src={boy}
                sx={{ borderRadius: "20px" }}
                width={"100%"}
              />
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            md={4.5}
            order={{ xs: 1, md: 2 }}
            sx={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
            }}
          >
            <Box
              mt={{ xs: 0, md: 8 }}
              sx={{
                display: "flex",
                flexDirection: "column",
                p: 2,
                borderRadius: "24px",
                background: "#55CB01",
                boxShadow:
                  "0px 2px 4px 0px #0000004D inset,0px -2px 4px 0px #FFFFFF8C inset",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Lilita One",
                  fontSize: { xs: "24px", sm: "50px" },
                  color: "#fff",
                }}
              >
                About BARFBOY
              </Typography>
              <Typography
                sx={{
                  my: 2,
                  fontFamily: "Montserrat",
                  fontSize: { xs: "16px", sm: "18px" },
                  color: "#fff",
                  pb: 5,
                }}
              >
                <span style={{ fontWeight: "700" }}>BARFBOY </span>
                isn’t just another memecoin—it’s a movement. Built for degens,
                by degens, this coin is here to shake up the crypto world with
                staking utility, max hype, and unstoppable energy. Whether
                you're here for the memes or the moon, one thing’s for sure—you
                don’t want to be the one left holding the bag of regrets!
                <br />
                <br />
                Don't Sleep on BARFBOY - This One's About to Blow!
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default About;
